// extracted by mini-css-extract-plugin
module.exports = {"infoInterviewContainer":"styles_infoInterviewContainer__1YzjV","totalAverageScore":"styles_totalAverageScore__2amjB","infoApplyContainer":"styles_infoApplyContainer__1TrMm"};